import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { Z_INDEX } from 'interfaces/constants'

export const StyledFixedAdBlock = styled.div`
  position: fixed;
  z-index: ${Z_INDEX.adBlock};
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  background: none;
  transition: transform 0.3s ease-in-out;
  ${MediaQueries.mbUp} {
    left: 50%;
    width: fit-content;
    transform: translateX(-50%);
  }
  .close-sticky-button {
    position: absolute;
    display: flex;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;
    background: #bfbfbf;
    border-radius: 50%;
    color: white;

    cursor: pointer;
    font-size: 12px;
    line-height: 12px;
    transform: translate(50%, -50%);
    top: 0;
    right: 0;
  }
  opacity: 0;
  pointer-events: none;
  &[data-visible='true'] {
    opacity: 1;
    pointer-events: auto;
  }
`

export const StyledAdContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 100%;
  ${MediaQueries.mbUp} {
    width: fit-content;
    height: fit-content;
  }
  margin-inline: auto;
  /* margin: 1rem auto; */
  &[data-no-wrapper='false'] {
    border: 1px solid ${theme.colors.neutral50};
    background: ${theme.colors.neutral50};
  }
  &[data-no-wrapper='true'] {
    line-height: 0;
  }
  &[data-header-bottom='true'] {
    flex-direction: column-reverse;
    background: none;
    border: none;
  }
  // Layout for sticky video
  ${MediaQueries.mbDown} {
    [data-video='true'] [data-gc-instream-floating='true'] {
      height: 100px !important;
      div[class^='InstreamDom_player'] {
        &[data-arb-resize-mode='compute-height']:not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_):not(#_) {
          height: 100px !important;
        }
        div:last-child {
          width: 180px !important;
        }
      }
      div[class^='InstreamDom_videoTitle'] {
        position: absolute !important;
        left: 180px !important;
        top: 50%;
        transform: translate(0, -50%);
        z-index: 999 !important;
        color: white !important;
        display: block !important;
        white-space: normal !important;
        text-align: left !important;
        font-size: 14px !important;
        line-height: 22px !important;
        font-weight: normal !important;
        padding: 0 16px !important;
        width: auto !important;
        height: auto !important;
        max-height: 66px !important;
      }
      div[class^='CloseButton'] {
        top: 23px !important;
        color: white !important;
        border-color: transparent !important;
      }
    }
  }
`

export const StyledAdHeader = styled.div`
  /* background: ${theme.colors.neutral50}; */
  width: 100%;
  padding: 0 5px 1.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-transform: capitalize;
  img {
    height: 12px;
    width: 12px;
    max-width: 12px;
    max-height: 12px;
  }
  &[data-header-bottom='true'] {
    background: ${theme.colors.neutral50};
  }
  span {
    font-size: 10px;
    line-height: 12px;
    color: ${theme.colors.gray400};
    font-weight: 400;
  }
`

export const StyledCloseBtn = styled.div`
  background-color: white;
  background-image: url('/images/close-blue.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
`
